export {}

const toggleableElements = document.querySelectorAll<HTMLElement>('[data-toggle-trigger]')

toggleableElements.forEach((element) => {
  const triggerSelector = element.dataset.toggleTrigger;

  if (!triggerSelector) return

  const trigger = element.querySelector<HTMLElement>(triggerSelector)

  if (!trigger) return

  trigger.addEventListener('click', (e) => {
    e.preventDefault()
    trigger.classList.contains('--triggered') ? trigger.classList.remove('--triggered') : trigger.classList.add('--triggered')
    element.classList.contains('--toggled') ? element.classList.remove('--toggled') : element.classList.add('--toggled')
  })
})
